import type { HttpAdapter } from "../../core/adapters/axios.adapter";
import type { GraphDataObject } from "../data/historical-chart.data";
import { chartFromGraphDataObject } from "../adapters/transformers/historical-charts/historical-chart.transforms";
import { Chart } from "../models/historical-charts/historical-chart.models";

const STABLECOINS_WIDGET_ALIASES = new Set(['stablecoins', 'latest/stablecoins', '/latest/stablecoins']);

export class ChartService {
  constructor(private httpAdapter: HttpAdapter, private widgetsAdapter: HttpAdapter) { }

  async load(chart: Chart | string): Promise<any> {
    const chartId = typeof chart === 'string' ? chart : chart.type;

    if (typeof chart === 'string') {
      if (STABLECOINS_WIDGET_ALIASES.has(chart)) {
        const response = await this.widgetsAdapter.get('stablecoins');
        return response.data;
      }
      const response = await this.httpAdapter.get(chart);
      return response.data;
    }

    const response = await this.httpAdapter.get<GraphDataObject>(`${chartId}?time_range=${chart.timeRange}`);
    const loadedChart = chartFromGraphDataObject(chart, response.data);
    return loadedChart;
  }

  async loadV2(chartId: string): Promise<any> {
    const response = await this.httpAdapter.get<GraphDataObject>(chartId);
    return response.data;
  }
}
